export enum DCUIThemingTextContentValidationTypes {
    LANDSCAPE = "landscape",
    PORTRAIT = "portrait"
}